var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjectPassive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5.293a1.58 1.58 0 1 0 0 3.16 1.58 1.58 0 0 0 0-3.16m-2.58 1.58a2.58 2.58 0 1 1 5.16 0 2.58 2.58 0 0 1-5.16 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.002 1.833c-2.278-.001-4.506 1.32-5.101 3.938-.705 3.113 1.225 5.813 3.04 7.562a2.96 2.96 0 0 0 4.112 0c1.822-1.75 3.75-4.443 3.046-7.556-.592-2.617-2.819-3.942-5.097-3.944m6.073 3.723C13.36 2.4 10.657.836 8.003.833 5.349.832 2.643 2.393 1.926 5.55c-.829 3.66 1.455 6.707 3.32 8.504l.001.001a3.96 3.96 0 0 0 5.5 0c1.872-1.798 4.156-4.838 3.328-8.498"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectPassive);
export default __webpack_public_path__ + "static/media/objectPassive.a321915c4a241cb54d9302f0ccafdfba.svg";
export { ForwardRef as ReactComponent };